import React from "react";
import "../style/home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="home-settings">
      <h1> Hello there!! &nbsp;:)</h1>
      <h2>Welcome and <br /> Feel free to play around with the CRUD operations:</h2>
      <div className = "list-position">
        <ul>
          <h2>1. <Link to = "/addProduct"> Add a new Product</Link></h2>
          <h2>2. <Link to = "/listProducts"> List, Edit and Delete a product</Link></h2>
        </ul>
      </div>
    </div>
  );
};

export default Home;